// extracted by mini-css-extract-plugin
export default {"recos":"K2-z","productCardOverride":"L2-z","rowHasBadge":"M2-z"};